import type { ScanResult } from '../upload-scanned'

export const isForbidden = (raw: unknown) =>
    (raw as { message?: string } | null)?.message?.toLowerCase() === 'forbidden'

// the `in` checks run against the parsed payload without a typeof guard, so a primitive frame throws
// here exactly as it does today - see the malformed frame characterization
export const isScanResult = (raw: unknown): raw is ScanResult =>
    'scanResultStatus' in (raw as object) && 'isMalicious' in (raw as object)
